import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { OrgInfo, GetOrganizationParams, GetOrganizationOptions } from '@nx-frontend/shared/types';
import { decideLogLevelForError, logger } from '@nx-frontend/shared/utils';

export async function getOrgInfo(
  { globalId }: GetOrganizationParams,
  options: GetOrganizationOptions
): Promise<OrgInfo | null> {
  const { userId } = options;
  let orgInfo: OrgInfo | null = null;

  try {
    const response = await axiosClient.get<OrgInfo>(`${generalEnv.orgServiceUrl}/v1/orgs/${globalId}/info`, {
      params: {
        newSubscriptionType: 'true',
      },
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    });
    orgInfo = response.data;
  } catch (err) {
    logger[decideLogLevelForError(err)](`getOrgInfo for %s error: %j`, globalId, err);
  }

  return orgInfo;
}
